<template>

    <div class="login_name" v-if="userInfo.group_id">
        <div class="user_box">
            <div class="user_list">
                <div>
                    <span>{{ userText }}</span>
                    <span style="color:rgb(153, 153, 153);font-size:12px;">(有效期至永久有效)</span>
                </div>
                <span v-if="String(userInfo.guan_zhu_id) > '0' "  style="margin-left: 10px;">
                    <img :src="zizhanghao" style="width: 18px;height: 18px;"/>
                </span>
                <!-- <div class="user_a">
                    <a href="">开通</a>
                </div> -->
            </div>
            <div class="user_list">
                <div class="user_span">
                    <span>余额 {{ userInfo.balance }}</span>
                    <span>赠送金 {{ userInfo.jifen }}</span>
                </div>
                <!-- <div class="user_a">
                    <a @click="showRechange">充值</a>
                </div> -->
            </div>
        </div>
        <!-- <div class="user_content">
            <div class="user_tabs">
                <a>个人额度</a>
            </div>
            <div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">店铺数量</div>
                <div>
                    <span>0</span>
                    <span>/10个</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">我的主题</div>
                <div>
                    <span>0</span>
                    <span>/10个</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">设计次数</div>
                <div>
                    <span>0</span>
                    <span>/10次</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">图库容量</div>
                <div>
                    <span>0</span>
                    <span>/10张</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">私有模板</div>
                <div>
                    <span>0</span>
                    <span>/10个</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content: space-between;">
                <div style="color:#595959">子账号</div>
                <div>
                    <span>0</span>
                    <span>/10个</span>
                </div>
                </div>
                <div >
                <div class="demo-progress">
                    <el-progress :percentage="0" :stroke-width="10"  :show-text="false"/>
                </div>
                </div>
            </div>
            
            </div>
        </div> -->
        <div style="color:#595959;display: flex;justify-content: space-between;">
            <!-- <div class="login_name_last">
                <i class="iconfont">&#xe63f;</i>
                <router-link to="/bill">我的账单</router-link>
            </div> -->
            <div class="login_name_last">
                <i class="iconfont">&#xe61c;</i>
                <router-link to="/setting">设置</router-link>
            </div>
            <div class="login_name_last" @click="clickLoginOut">
                <i class="iconfont">&#xe658;</i>
                退出
            </div>
        </div>
        <Rechange v-if="isShowRechange" @closeRechange="closeRechange" />
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { useCounterStore } from '../../store/userInfo'
import { storeToRefs } from 'pinia'
import { ElLoading, ElMessage } from 'element-plus'
import { UserFilled } from '@element-plus/icons-vue'
import Rechange from '@/views/home/Rechange.vue'
import QRCode from 'qrcode';
import { Timeout } from 'timers';
import zizhanghao from '@/assets/images/zizhanghao.png'


const store = useCounterStore()

const { userInfo, userText } = storeToRefs(store)
const isShowRechange = ref(false)
const emit = defineEmits(['showConfirm'])

function clickLoginOut() {
    emit('showConfirm')
}

function showRechange() {

    isShowRechange.value = true
}
let loop = true;
let ordernum = '';
let intervalId: Timeout;
async function closeRechange(s: any) {
    console.log(s);
    console.log(isShowRechange.value);
    let loading = ElLoading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(0,0,0,0.1)'
    })
    try {
        if (s.name == 'confirm') {
            clearInterval(intervalId);
            if (!s.money) {
                ElMessage.error("请输入金额！")
            } else {
                const { code = 100, data = {} } = await store.rechargeOrder({ money: parseFloat(s.money), type: s.type }) || {}
                if (code == 101) {
                    const qrCode = await QRCode.toDataURL(data.code_url, {
                        width: 128,
                        color: {
                            dark: '#000',
                            light: '#fff'
                        }
                    });

                    document.getElementById('qrCodeImg').setAttribute('src', qrCode);
                    ordernum = data.ordernum;
                    // chekOrderStatus(data.ordernum);
                    if (loop) {
                        intervalId = setInterval(() => {
                            chekOrderStatus(ordernum);
                        }, 2000); // 每1000毫秒（1秒）调用一次 chekOrderStatus

                        // 如果 loop 变为 false，清除定时器
                        chekOrderStatus(ordernum).finally(() => {
                            if (!loop) {
                                clearInterval(intervalId);
                            }
                        });
                    }
                    const alipaysubmitRef = document.querySelector("#alipaysubmitRef") as any
                    alipaysubmitRef.innerHTML = data
                    const alipaysubmit = document.querySelector("#alipaysubmit") as any
                    alipaysubmit && alipaysubmit.submit()
                    // isShowRechange.value = false
                } else if (code == 102) {
                    window.location.href = data.form_params;
                } else {
                    ElMessage.error(data || "网络繁忙，请稍后再试！")
                }
            }
        } else {
            store.qrCodeUrl = '';

            isShowRechange.value = false
        }
        loading.close()
    } catch (e) {
        store.qrCodeUrl = '';

        loading.close()
    }
}

async function chekOrderStatus(s: any) {
    const { data = {} } = await store.isRechargeOrderPaid({ orderId: s }) || {}
    if (data.result) {
        loop = false;
        ElMessage.success("支付成功！")
        window.location.href = 'https://mszxdz.com/mt/#/username';
    }
}
</script>
<style scoped>
.header_title:hover .login_name {
    display: block;
}

.login_name {
    position: absolute;
    top: 59px;
    right: 0;
    width: 370px;
    padding: 0 20px;
    background-color: #fff;
    color: rgb(153, 153, 153);
    box-shadow: 2px 0px 10px 0px rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.login_name .login_name_last a {
    cursor: pointer;
    color: #595959;
}

.login_name .login_name_last a:hover,
.login_name .login_name_last:hover {
    color: #8583C2;
    cursor: pointer;
}

.login_name .user_a a {
    cursor: pointer;
    color: #007df2;
}

.user_box {
    border-bottom: 1px solid #E8E8E8;
    padding: 15px 0;
}

.user_list {
    display: flex;
    justify-content: space-between;
    color: #595959;
    line-height: 30px;
}

.user_span span {
    margin-right: 15px;
}

.login_name .user_content {
    padding-bottom: 10px;
    border-bottom: 1px solid #E8E8E8;
}

.login_name .user_content a {
    color: #007df2;
}

.user_tabs {
    line-height: 22px;
    padding-top: 10px;
}
</style>